import clsx from 'clsx';
import { getForecastContext } from './periods';
import { useTableSettings } from './TableSettingsContext';

interface SectionHeaderProps {
  label: string;
  colSpan?: number;
  className?: string;
}

export function SectionHeader({ label, className }: SectionHeaderProps) {
  const { settings } = useTableSettings();
  const numQuarters = settings ? getForecastContext(settings).numQuarters : 16;

  return (
    <tr className={clsx('bg-gray-100', className)}>
      <td
        colSpan={1 + numQuarters}
        className="px-3 py-2 text-sm font-bold text-gray-800 border-b border-gray-300 uppercase tracking-wide"
      >
        {label}
      </td>
    </tr>
  );
}
